module.exports = __webpack_public_path__ + "img/ic-logout-arrow.5f89d199.svg";